export default "__VITE_ASSET__CITr3KsE__"